module.exports = __webpack_public_path__ + "img/symbol_hashgreen.f59be7cd.png";